import React from 'react';
import IconButton from '../IconButton/IconButton';
import Icons from '../IconButton/Icons';
import {openSupport} from '../../Support/messenger';

/**
 * IconButton that opens an article inside the support widget.
 * @param {ArticleButtonProps} props
 * @constructor
 */
function ArticleButton(props: ArticleButtonProps) {
    /**
     * Show the article passed in the props
     */
    function onClick() {
        openSupport({article: props.article});
    }

    return <IconButton type={Icons.CAP}
                       color='blue'
                       label={props.label}
                       textColor='blue'
                       onClick={onClick}
                       clickPassthrough={false}
    />;
}

export type ArticleButtonProps = {
    article: string,
    label: string,
}

export default ArticleButton;
